import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MAX_PHOTOS_PER_AD } from '@barter/shared';
import { photoUrl } from '../../services/api-base';

interface PhotoUploaderProps {
  previews: string[];
  onAdd: (files: File[]) => void;
  onRemove: (index: number) => void;
}

export function PhotoUploader({ previews, onAdd, onRemove }: PhotoUploaderProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const remaining = MAX_PHOTOS_PER_AD - previews.length;
    const toAdd = files.slice(0, remaining);
    if (toAdd.length) onAdd(toAdd);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div className="photo-uploader">
      <div className="photo-uploader__list">
        {previews.map((url, i) => (
          <div key={i} className="photo-uploader__item">
            <img src={photoUrl(url)} alt="" />
            <button className="photo-uploader__remove" onClick={() => onRemove(i)}>
              ✕
            </button>
          </div>
        ))}
        {previews.length < MAX_PHOTOS_PER_AD && (
          <button className="photo-uploader__add" onClick={() => inputRef.current?.click()}>
            <span>📷</span>
            <span className="photo-uploader__add-label">{t('common.photo')}</span>
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        onChange={handleChange}
        className="photo-uploader__input"
      />
    </div>
  );
}
